import axios from "axios";
import env from "../variables/EndpointEnvironment";

const FindUsAPI = (props) => {
  return axios.get(
    `${env.HOST}/find-us?orderBy=desc&limit=${props.limit}&page=${props.page}&search=${props.search}`,
    {
      headers: {
        "Content-Language": localStorage.getItem('i18nextLng'),
      },
    }
  );
};

export default FindUsAPI;
